import { Label, FormGroup, Select } from '@celltrak/ui-components';

import { useAction } from '../../../Common/hooks';
import { rowsPerPageOptions } from '../../constants';
import { setRejectedPagination } from '../../actions';
import usePagination from '../Paginator/hooks';

const RowCountSelector = () => {
  const { pageSize } = usePagination();
  const setPagination = useAction(setRejectedPagination);
  const toNumber = value => parseInt(value, 10);
  const selectedSize = pageSize.toString();

  return (
    <FormGroup inline>
      <Label for="rejected_rowsPerPage" size="sm">
        Show:
      </Label>
      <Select
        id="rejected_rowsPerPage"
        size="sm"
        value={selectedSize}
        options={rowsPerPageOptions}
        onChange={event => setPagination({ pageSize: toNumber(event.target.value) })}
      />
    </FormGroup>
  );
};

export default RowCountSelector;
